import { useQuery } from '@tanstack/react-query'
import request from '@/services/request'
import { Paginated } from '@/types/utility.types'
import { ApiNotification } from '@/types/notification'

export const useGetNotifications = (enabled = true) => {
  return useQuery<Paginated<ApiNotification>>({
    queryKey: ['notifications'],
    queryFn: () =>
      request.private
        .get<Paginated<ApiNotification>>('notifications/', {
          params: { page_size: 20 },
        })
        .then((r) => r.data),
    staleTime: 30_000,
    enabled,
  })
}
